import {default as shareSimulationProperties} from './shareSimulationProperties';
import {default as withdrawRedemptionProperties} from './withdrawRedemptionProperties';
import {default as withdrawRetirementProperties} from './withdrawRetirementProperties';

export default {
    shareSimulationProperties,
    withdrawRetirementProperties,
    withdrawRedemptionProperties
};
